import React from 'react';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Row } from 'shared/components/birch/row';
import CandidateChips, {
  hasNonTagChips,
} from 'talent_matching/components/shared/candidate_chips';
import { RejectModalProvider } from 'application_review/components/reject_modal_context';
import SocialLinks from 'talent_matching/components/shared/social_links';
import { Person } from 'talent_matching/types';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { NeutralTag } from 'talent_matching/components/shared/styled_tag';
import noop from 'lodash/noop';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.rediscovery.table.rediscovery_candidate_cell'
);

type Props = {
  applicationId: number;
};

const RediscoveryCandidateCell = ({ applicationId }: Props) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  const appCountsSuffix = application.matchingAppsCount === 1 ? 'one' : 'other';
  return (
    <Stack
      spacing={1}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      <Row spacing={0.5}>
        <SecondaryBody medium className="candidate-full-name pii-blur">
          {application.fullName}
        </SecondaryBody>
      </Row>
      <Stack spacing={2}>
        <NeutralTag
          text={t(`matching_apps.${appCountsSuffix}`, {
            matching: application.matchingAppsCount,
            count: application.totalAppsCount,
          })}
        />
        {hasNonTagChips(application as unknown as Person) && (
          <CandidateChips application={application as unknown as Person} />
        )}
      </Stack>
      <RejectModalProvider>
        <SocialLinks
          application={application as unknown as Person}
          onRejectSuccess={noop}
        />
      </RejectModalProvider>
    </Stack>
  );
};

export default RediscoveryCandidateCell;
